'use client';

import React, { ReactNode } from 'react';
import Button from '@/ui/components/shared/Button';

export type Option = {
  text: string;
  value: string;
};

export type ICSelectWithImagesProps = {
  notice?: string | ReactNode;
  options: Option[];
  onSelect: (value: any) => void;
};

export function ICNotice({ notice, options, onSelect }: ICSelectWithImagesProps) {
  return (
    <div className="mx-auto flex w-full max-w-lg flex-grow flex-col justify-between">
      <div className="relative mb-4 rounded-lg bg-primary-20 px-4 py-3 pr-6 text-start">
        <p>{notice}</p>
      </div>
      <div className="grid auto-rows-auto grid-cols-1 justify-center gap-2 md:grid-cols-2">
        {options.map((option, index) => (
          <div key={index} className="col-span-1 flex flex-col items-center">
            <Button
              variant="yellowBlackBorder"
              className="w-full"
              onClick={(e) => {
                onSelect(option.value);
                const target = e?.target as HTMLButtonElement;
                target?.blur(); // Remove focus after click
              }}
            >
              {option.text}
            </Button>
          </div>
        ))}
      </div>
    </div>
  );
}
